module.exports = __webpack_public_path__ + "static/media/riverwalk-thumb.f43aa978.jpg";